<script setup>
import { computed } from "vue";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const columns = [
  { sorter: false },
  {
    title: "Expense Name",
    dataIndex: "name",
    key: "name",
    sorter: (a, b) =>
      String(a.name || "")
        .toLowerCase()
        .localeCompare(String(b.name || "").toLowerCase()),
  },
  {
    title: "Date",
    dataIndex: "expense_date",
    key: "expense_date",
    sorter: (a, b) =>
      new Date(a.expense_date || a.created_at || 0) -
      new Date(b.expense_date || b.created_at || 0),
  },
  {
    title: "Payment Method",
    dataIndex: "payment_method",
    key: "payment_method",
    sorter: (a, b) =>
      String(a.payment_method || "")
        .toLowerCase()
        .localeCompare(String(b.payment_method || "").toLowerCase()),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    sorter: (a, b) => Number(a.amount || 0) - Number(b.amount || 0),
  },
];

const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};

const tableData = computed(() => props.items || []);
</script>

<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="tableData"
    :row-selection="rowSelection"
    :pagination="false"
    row-key="id"
    :loading="loading"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'name'">
        <h6 class="fs-14 fw-medium">{{ record.name }}</h6>
      </template>

      <template v-else-if="column.key === 'expense_date'">
        <span>{{ record.expense_date || "-" }}</span>
      </template>

      <template v-else-if="column.key === 'payment_method'">
        <span>{{ record.payment_method || "-" }}</span>
      </template>

      <template v-else-if="column.key === 'amount'">
        <span>
          {{ record.currency || "KES" }}
          {{ Number(record.amount || 0).toLocaleString() }}
        </span>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 700px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
